<template>
    <div>
        <Loading :loading="loading"/>
        <Edit
            :tipo="tipoSelecionado"
            :campos="camposEditados"
            :close="closeEdit"
            :onSubmit="onSubmit"
            :formatos="formatos"
        />
        <CAlert show color="light">
            Campos mapeados são utilizados no momento da integração com plataformas de terceiros,
            é uma forma de normatizar tanto os dados de saída quanto os de entrada.
        </CAlert>

        <div class="grupos-grid">
            <div
                v-for="(grupo, chaveGrupo) in grupos"
                :key="chaveGrupo"
                class="grupo-card"
            >
                <div class="grupo-header">
                    <div class="grupo-icon">
                        <fa-icon :icon="getIconeGrupo(chaveGrupo)" />
                    </div>
                    <div class="grupo-info">
                        <div class="grupo-nome">{{ grupo.titulo }}</div>
                        <div class="grupo-desc">{{ Object.keys(grupo.tipos).length }} tipo(s)</div>
                    </div>
                </div>

                <div class="tipos-list">
                    <div
                        v-for="(tipo, chaveTipo) in grupo.tipos"
                        :key="chaveTipo"
                        class="tipo-item"
                        @click="openEdit(chaveTipo, tipo)"
                    >
                        <div class="tipo-info">
                            <div class="tipo-nome">{{ tipo.titulo }}</div>
                            <div class="tipo-chave">{{ chaveTipo }}</div>
                        </div>
                        <div class="tipo-meta">
                            <span class="badge-campos">
                                {{ getQtdCampos(chaveTipo) }} campo(s)
                            </span>
                            <fa-icon icon="pencil-alt" class="tipo-edit-icon" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { get, put } from '../../helpers/apiRequest';
  import clone from 'just-clone';
  import Edit from "./components/Edit";

  export default {
    name: "CamposIntegracao",
    components: {
      Edit
    },
    data() {
      return {
        loading: false,
        grupos: {},
        campos: {},
        formatos: {},
        tipoSelecionado: {},
        camposEditados: [],
      };
    },
    methods: {
      getIconeGrupo(chave) {
        const icones = {
          cliente: 'user',
          pedido: 'clipboard-list',
          lead: 'user-tie',
          logistica: 'truck',
          sac: 'headset',
        };
        return icones[chave] || 'cogs';
      },
      getQtdCampos(tipo) {
        return this.campos[tipo] ? this.campos[tipo].length : 0;
      },
      openEdit(chaveTipo, tipo) {
        this.tipoSelecionado = clone(tipo);
        this.tipoSelecionado.chave = chaveTipo;
        this.camposEditados = this.campos[chaveTipo] ? clone(this.campos[chaveTipo]) : [];
        this.$modal.show('editCampo');
      },
      closeEdit() {
        this.$modal.hide('editCampo');
      },
      loadGrupos() {
        get('/admin/grupos-campos-integracao')
          .then((response) => this.grupos = response);
      },
      loadCampos() {
        get('/admin/campos-integracao')
          .then((response) => this.campos = response);
      },
      loadFormatos() {
        get('/admin/campos-integracao/formatos')
          .then((response) => this.formatos = response);
      },
      onSubmit(campos, tipo) {
        this.loading = true;
        put(`/admin/campos-integracao/${tipo}`, campos)
          .then((response) => {
            this.$swal({
              title: 'Sucesso!',
              text: response.message,
              icon: 'success',
            });
            this.loadCampos();
            this.closeEdit();
            this.loading = false;
          })
          .catch((err) => {
            this.$swal({
              title: 'Ops!',
              text: err.message,
              icon: 'error',
            });
            this.loading = false;
          });
      }
    },
    beforeMount() {
      this.loadGrupos();
      this.loadCampos();
      this.loadFormatos();
    }
  }
</script>

<style scoped>
.grupos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  margin-top: 16px;
}

.grupo-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.grupo-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.grupo-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eceaf3;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3a3e81;
  font-size: 16px;
  flex-shrink: 0;
}

.grupo-nome {
  font-weight: 600;
  font-size: 15px;
  color: #1d2939;
}

.grupo-desc {
  font-size: 12px;
  color: #667085;
  margin-top: 2px;
}

.tipos-list {
  padding: 8px 0;
}

.tipo-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  cursor: pointer;
  transition: background 0.15s;
}

.tipo-item:hover {
  background: #f9fafb;
}

.tipo-nome {
  font-weight: 500;
  font-size: 14px;
  color: #344054;
}

.tipo-chave {
  font-size: 11px;
  color: #98a2b3;
  margin-top: 2px;
  font-family: monospace;
}

.tipo-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.badge-campos {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #d0d5dd;
  color: #667085;
  background: #f9fafb;
}

.tipo-edit-icon {
  color: #98a2b3;
  font-size: 13px;
  transition: color 0.15s;
}

.tipo-item:hover .tipo-edit-icon {
  color: #3a3e81;
}
</style>
